<template>
  <node-view-wrapper class="editor-wrapper-std igi">
    <node-view-content class="content-dom" />

    <div class="igi__controls" contenteditable="false">
      <v-icon @click="colSettings">
        mdi-cog
      </v-icon>
    </div>

    <col-settings-dialog
      v-model="settingsDialog"
      :classes="classes"
      @apply="setSettings"
      @close="closeSettings"
      @remove="removeNode"
    />
  </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper, NodeViewContent } from "@tiptap/vue-2";
import ColSettingsDialog from "./FlexSettings/ColSettingsDialog.vue";

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent,
    ColSettingsDialog
  },
  props: nodeViewProps,
  data() {
    return {
      settingsDialog: false,
      classes: ""
    };
  },
  methods: {
    colSettings() {
      this.classes = this.node.attrs.class;
      this.settingsDialog = true;
    },
    closeSettings() {
      this.settingsDialog = false;
    },
    setSettings(value) {
      const v = value.join(" ");
      this.updateAttributes({
        class: "aunfcol col" + (v.length ? ` ${v}` : "")
      });
    },
    removeNode() {
      this.deleteNode();
    }
  }
};
</script>

<style lang="scss" scoped>
.igi {
  background: #fff;
  border: 1px solid #0d0d0d;
  margin: 8px;
  position: relative;
  flex-grow: 0;
  max-width: 300px;
  min-width: 200px;

  .igi__controls {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    color: black;
  }
}
.flexcol {
  border: 1px solid;
  min-width: 250px;
  min-height: 100px;
}
</style>
